import './App.scss';
import banner from '../../assets/vii-banner.jpg';

import React, { useContext } from 'react';
import { SegmentContext } from '../../index'
import Library from '../Library';
import SolutionSelector from '../SolutionSelector';
import Button from '../Button';
import Slotter from '../Slotter'

export const solutionFilter = (item, index) => {
  const { name } = item
  if (['all'].indexOf(name) !== -1) {
    return false
  }
  return true
}

function App() {

  const { segments, segment, solution, selectSegment, selectSolution, selectSolutionWithDelay } = useContext(SegmentContext)

  return (
    <div className="App">

      { !segment && (
        <>

        <img width="1170" height="390" src={banner} alt="" className="img-responsive mb-1" />

        <h1 className="title">Valmet Industrial Internet – VII</h1>
        <h2 className="subtitle">Application catalogue</h2>

        <p className="lead">To get started, click on the industry or VII solution name below!</p>
        
        <Slotter className="segment-container" minWidth={768} gap="md">
          { segments.map((seg, index) => {
            return (
              <div key={index} className="segment">
                <div className="segment-head">
                  <h3 onClick={e => {
                    selectSegment(seg.id)
                    selectSolution(null)
                  }}>{seg && seg.name}</h3>
                </div>

                <div className="segment-body">
                  <ul className="Solutions">
                    { seg.solutions.filter(solutionFilter).map((sol, key) => {
                      return (
                        <li key={key} className="solution">
                          <button onClick={e => {
                            selectSegment(seg.id)
                            selectSolutionWithDelay(sol.id)
                          }}>
                            {sol.name}
                          </button>
                        </li>
                      )
                    }) }
                  </ul>
                </div>
              </div>
            )
          }) }
        </Slotter>
        
        </>
      ) }

      { segment && (
        <>
          <div className="bar">
            <Button
              className="back"
              onClick={e => {            
                selectSegment(null)
                selectSolution(null)
              }}
              label="< Back"
            />

            <div className="color-codes">
              <div className="color-code">
                <span className="common"></span> Common application to all process parts
              </div>
              <div className="color-code">
                <span className="process"></span> Process part related application
              </div>
            </div>

            <div className="text-right">
              <label>Change industry:</label>
              <select value={segment ? segment.id : null} onChange={e => { 
                selectSegment(e.target.value)
                selectSolution(null)
              }}>
                { segments.map((seg, index) => {
                  return (
                    <option key={index} value={seg.id}>{seg.name}</option>
                  )
                }) }
              </select>
            </div>
          </div>
          <h1 className="solution-title">{ segment && segment.name}{ solution && ` - ${solution.name}`}</h1>
          <p className="lead lead-segment">{segment.info}</p>
          <label>Select solution:</label>
          <SolutionSelector />          
          <Library />
        </>
      ) }

    </div>
  );
}

export default App;
